import { Component, Input, Output, EventEmitter, OnDestroy, ViewChild } from '@angular/core';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { NgxExtendedPdfViewerComponent } from 'ngx-extended-pdf-viewer';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss'],
  standalone: false
})
export class PdfViewerComponent implements OnDestroy {
  private destroy$ = new Subject<void>();

  @Input() set pdfSrc(value: string | Blob | null) {
    this.pdfSrc$.next(value);
  }
  @Input() set loading(value: boolean) {
    this.loading$.next(value);
  }
  @Output() pdfLoaded = new EventEmitter<void>();

  @ViewChild('pdfViewer') pdfViewer: NgxExtendedPdfViewerComponent;

  public pdfSrc$ = new BehaviorSubject<string | Blob | null>(null);
  public loading$ = new BehaviorSubject<boolean>(false);

  constructor() {
    this.pdfSrc$.pipe(takeUntil(this.destroy$)).subscribe((pdf) => {
      if (this.pdfViewer && pdf) {
        if (typeof pdf === 'string') {
          this.pdfViewer.src = encodeURIComponent(pdf);
        } else {
          this.pdfViewer.src = pdf;
        }
        this.pdfViewer.openPDF2();
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
  }

  onPdfLoaded() {
    this.loading$.next(false);
    this.pdfLoaded.emit();
  }
}
